export default __webpack_public_path__ + "static/media/asm.634b4922.png";